export default __webpack_public_path__ + "static/media/search_result.2b6bd395.png";